/**
 * My Work route wrapper — switches between v2 (feature-flagged) and legacy.
 *
 * When both `staff_portal_v2_enabled` and `staff_my_work_v2_enabled` are
 * ON, the existing MyWorkPage.jsx is wrapped in StaffPortalShell for the
 * consistent navigation/header experience. Otherwise the legacy page
 * renders exactly as before (no shell, no changes).
 *
 * A dedicated "MyWorkPageV2" component isn't authored in this slice — the
 * existing MyWorkPage.jsx already covers real API data with permission
 * gating for all My Work features. Wrapping it in the shell delivers the
 * v2 IA and navigation surface without touching the working card grid.
 */
import React from 'react';
import LegacyMyWork from '@/pages/staff/MyWorkPage';
import StaffPortalShell from '@/components/staff-v2/StaffPortalShell';
import { useStaffV2Flags } from '@/lib/staffV2Flags';

export default function MyWorkRoute() {
  const flags = useStaffV2Flags();
  if (flags.loading) {
    return <div className="min-h-[40vh] flex items-center justify-center text-sm text-muted-foreground" aria-busy="true">Loading…</div>;
  }
  if (flags.staff_portal_v2_enabled && flags.staff_my_work_v2_enabled) {
    return (
      <StaffPortalShell title="My Shifts" subtitle="Your shifts, timesheets and requests">
        <LegacyMyWork />
      </StaffPortalShell>
    );
  }
  return <LegacyMyWork />;
}
